<template>
  <div class="payment-create main-content">
    <form action @submit.prevent="submitPrepaymentRequestData">
      <div class="page-header">
        <h3 class="page-title">{{ $t("invoices.changePromisedDate") }}</h3>
        <ol class="breadcrumb">
          <li class="breadcrumb-item">
            <router-link slot="item-title" to="/super-admin/dashboard">
              {{
                $t("general.home")
              }}
            </router-link>
          </li>
          <li class="breadcrumb-item">
            <router-link
              v-if="$route.name === 'preapproved.invoice.verified'"
              slot="item-title"
              to="/super-admin/preapproved-invoices"
            >{{ $tc("preapproved_invoices.invoice", 2) }}</router-link>
            <router-link v-else slot="item-title" to="/super-admin/invoices">
              {{
                $tc("invoices.invoice", 2)
              }}
            </router-link>
          </li>

          <li class="breadcrumb-item">{{ $t("invoices.changePromisedDate") }}</li>
        </ol>
        <div class="page-actions row">
          <base-button
            :loading="isLoading"
            :disabled="isLoading"
            icon="save"
            color="theme"
            class="invoice-action-btn"
            type="submit">
            {{ $t('invoices.save_invoice') }}
          </base-button>
        </div>
      </div>
      <SinglePreapprovedInvoiceRow
        v-if="$route.name === 'preapproved.invoice.verified'"
        :fetchData="fetchData"
      />
      <SingleInvoiceRow v-else :fetchData="fetchData" />
      <SinglePrepaymentRequestRow :prepaymentRequest="prepaymentRequest" />
      <br><br>
      <div class="payment-card card">
        <div class="card-body">
          <div class="row">
            <div class="col-sm-6">
              <div class="form-group">
                <label class="form-label">{{ $t('invoices.new_promised_payment_date') }}</label><span class="text-danger"> *</span>
                <base-date-picker
                  v-model="formData.promised_payment_date"
                  :calendar-button="true"
                  :disabledDates = "{
                    to: new Date(Date.now())
                  }"
                  calendar-button-icon="calendar"
                  @change="$v.formData.promised_payment_date.$touch()"
                />
                <div v-if="$v.formData.promised_payment_date.$error">
                  <span v-if="!$v.formData.promised_payment_date.required" class="text-danger">{{ $t('validation.required') }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import SingleInvoiceRow from "../invoices/SingleInvoiceRow";
import SinglePreapprovedInvoiceRow from "../preapprovedInvoices/SingleInvoiceRow.vue";
import SinglePrepaymentRequestRow from "../prepayments/SinglePrepaymentRequestRow.vue";
import { mapActions, mapGetters } from "vuex";
import MultiSelect from "vue-multiselect";
import { validationMixin } from "vuelidate";
import moment from "moment";
const {
  required
} = require("vuelidate/lib/validators");
export default {
  components: {
    MultiSelect,
    SingleInvoiceRow,
    SinglePreapprovedInvoiceRow,
    SinglePrepaymentRequestRow
  },
  mixins: [validationMixin],
  data () {
    return {
      prepaymentRequest: [],
      customerCurrency: null,
      userType: null,

      formData: {
        promised_payment_date: 0
      },
      isLoading: false,
      isVerifiedButtonShow: true,
      isRejectedButtonShow: true,

      fetchData: [],
      percentageFormat: {
        precision: 2,
        thousand_separator: ",",
        decimal_separator: ".",
        symbol: "% ",
      },
      requestNumber: null
    }
  },
  created() {
    if (localStorage.getItem("role") == "super_admin") {
      this.userType = "super_admin";
    } else if (localStorage.getItem("account_type") == "anchor") {
      this.userType = "anchor";
    } else if (localStorage.getItem("account_type") == "supplier") {
      this.userType = "supplier";
    } else if (localStorage.getItem("account_type") == "funder") {
      this.userType = "funder";
    }
    this.loadInvoice()
  },
  validations () {
    return {
      formData: {
        promised_payment_date: {
          required
        }
      }
    }
  },
  computed: {
    ...mapGetters("currency", [
      "defaultCurrencyForInput",
      "selectedPrepaymentVerified",
    ]),
    ...mapGetters("payment", ["paymentModes"]),
  },
  watch: {},
  async mounted() {
    this.$nextTick(() => {
      this.loadData();
    });
  },
  methods: {
    ...mapActions("prepayment", ["fetchPrePaymentRequest", "fetchPrePayment"]),
    ...mapActions("invoice", ["fetchInvoice", "SingleInvoiceArray"]),
    ...mapActions("prepayment", [
      "fetchCreatePayment",
      "addPayment",
      "updatePayment",
      "fetchEditPaymentData",
      "createPrepaymentRequest",
      "addPrepaymentRequest",
      "editPrepaymentRequest",
      "updatePrepaymentRequest",
    ]),
    ...mapActions("modal", ["openModal"]),
    ...mapActions("LoanRequest", ["loanRequestStatus"]),
    async loadInvoice() {
      let response = await this.SingleInvoiceArray(this.$route.params.id);
      if (response.data) {
        this.fetchData = response.data.invoice;
      }
    },
    async loadData () {
      this.isLoading = true
      let res = await this.fetchPrePaymentRequest(this.$route.params.id);
      if (res.data) {
        this.prepaymentRequest = res.data.prepaymentRequest
        this.isLoading = false
      }
      let today = new Date()
      this.formData.promised_payment_date = moment(today).toString()
      return false
    },

    async submitPrepaymentRequestData () {
      this.$v.formData.$touch();
      if (this.$v.$invalid) {
        return true
      }
      let data = {
        id: this.$route.params.id,
        promised_payment_date: moment(this.formData.promised_payment_date).format('DD/MM/YYYY')
      }
      this.isLoading = true

      let response = await this.updatePrepaymentRequest(data)
      if (response.data.success) {
        this.isLoading = false
        window.toastr['success'](this.$tc('invoices.promised_date_change_successfully'))
        this.$router.push('/super-admin/invoices')
        return true
      }
    }
  }
}
</script>
<style scoped>
.table-component {
  min-height: 0px;
}
</style>
